import angular from 'angular';
import currencyFormatting from './currencyFormatting';

export default angular
  .module('components.currencyFormatting', [])
  .component('currencyFormatting', currencyFormatting).name;
